import Branding from 'shared/branding';
import useBrandingHostProps from './useBrandingHostProps';

export default function BrandingSettingsPage() {
  const hostProps = useBrandingHostProps();

  return <Branding {...hostProps} />;
}
